import{e as S,m as t}from"./chunk-HBP5N4FR.js";var s,R,n,o=S(()=>{t();s="transaction-status-toast-id",R=6e3,n=5});export{s as a,R as b,n as c,o as d};
//# sourceMappingURL=chunk-MV7THB7B.js.map
